<template>
    <card class="card-default">
        <card-header><b> Advanced Settings for {{ campaign.name }}</b></card-header>
        <card-body v-if="form">
            <div class="row mb-4" v-if="type !== 'public'">
                <div class="col-md-5">
                    <rate :image="form.image" :type="type" :question="form.rating_message"
                        :submitText="form.submit_button_rating" :form="form" field="submit_button_rating">
                    </rate>
                </div>
                <div class="col-md-7">
                    <label>Rating Message</label>
                    <textarea class="form-control" :placeholder="isRating"
                        v-model="form.rating_message"
                        :class="{ 'is-invalid': hasError('rating_message') }"></textarea>
                    <span class="mb-2 invalid-feedback">{{ hasError('rating_message') }}</span>
                    <input-text placeholder="Submit" label="Submit Button Rating"
                        v-model="form.submit_button_rating"
                        :form="form" field="submit_button_rating">
                    </input-text>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-5">
                    <feedback-review
                        :text="form.feedback_message"
                        :textSubmit="form.submit_button_feedback"
                        :textBack="form.back_button_feedback">
                    </feedback-review>
                </div>
                <div class="col-md-7">
                    <input-text  label="Feedback Message" field="feedback_message"
                        v-model="form.feedback_message"
                        :form="form"
                        :placeholder="feedbackMessage">
                    </input-text>
                    <div class="small mb-2" v-if="type === 'cx'">
                        Is necessary use the mark<strong>&nbsp;:rating&nbsp;</strong>because this will be the place
                        where the number of stars will be displayed.<br/><strong>Input:</strong>Please tell us why you
                        chose :rating stars.<br/><strong>Output:</strong>Please tell us why you chose 5 stars.
                    </div>
                    <div class="small mb-2" v-if="type === 'nps'">
                        The number will be displayed in the final of the phrase.<br/>
                        <strong>Example:</strong>Please tell us why you chose 10.
                    </div>
                    <input-text placeholder="Submit" label="Submit Button Feedback"
                        v-model="form.submit_button_feedback"
                        :form="form"
                        field="submit_button_feedback">
                    </input-text>
                    <input-text placeholder="Back" label="Back Button Feedback"
                        v-model="form.back_button_feedback"
                        :form="form" field="back_button_feedback">
                    </input-text>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-5">
                    <share :image="form.image"
                           :sites="review_sites"
                           :question="form.share_message"
                           :allowPrivateFeedback="form.allow_private_feedback"></share>
                </div>
                <div class="col-md-7">
                    <label>Share Message</label>
                    <textarea class="form-control" placeholder="Please select a site below to leave us a review"
                        v-model="form.share_message"
                        :class="{ 'is-invalid': hasError('share_message') }">
                    </textarea>
                    <span class="mb-2 invalid-feedback">
                        {{ hasError('share_message') }}
                    </span>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-5">
                    <thank-you :text="form.thank_you_message"></thank-you>
                </div>
                <div class="col-md-7">
                    <input-text placeholder="Thank you!!" label="Thank You Message"
                        v-model="form.thank_you_message"
                        :form="form" field="thank_you_message">
                    </input-text>
                </div>
            </div>
            <div class="float-right">
                <a class="swell-btn btn btn-secondary ml-2" :href="editUrl">
                    Cancel
                </a>
                <button class="swell-btn btn btn-primary ml-2" @click="send">Save</button>
            </div>
        </card-body>
    </card>
</template>

<script>
export default {
    props: {
        type: { type: String, required: true },
        campaign: { type: Object, required: true },
        settings: { type: Object, required: true },
    },

    data: () => ({
        form: null,
        review_sites: [
            'google',
            'facebook',
            'yelp',
        ],
    }),

    watch: {
        settings() {
            this.form = this.initFields();
        },
    },

    computed: {
        feedbackMessage() {
            return this.campaign.type !== 'public' ? 'Please tell us more about your experience' : 'Please tell us why you chose';
        },

        isRating() {
            return this.campaign.type !== 'public' ? 'How would you rate your experience with us?' : 'Please tell us why you chose';
        },
        editUrl() {
            return this.$laroute.route(`campaigns.${this.type}.edit`, { [this.type !== 'nps' ? this.type : 'np']: this.form.campaign_id });
        },
    },

    methods: {
        hasError(value) {
            return this.form.errors.get(value)
        },

        initFields() {
            return new Form({
                share_message: this.settings.share_message,
                rating_message: this.settings.rating_message,
                feedback_message: this.settings.feedback_message,
                submit_button_feedback: this.settings.submit_button_feedback,
                submit_button_rating: this.settings.submit_button_rating,
                back_button_feedback: this.settings.back_button_feedback,
                thank_you_message: this.settings.thank_you_message,
                image: this.campaign.image,
                allow_private_feedback: this.campaign.allow_private_feedback,
                campaign_id: this.campaign.id
            });
        },

        send() {
            this.form
                .post(this.$laroute.route('campaigns.settings-store', {campaign: this.campaign.id}))
                .then(() => window.location.replace(this.editUrl));
        },
    },
};
</script>
